export default "__VITE_ASSET__916c1071__"